"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cast = void 0;
// @TODO: Find what's the source of thruth for this (character CDN?) and fetch data from there.
exports.cast = {
    wow: {
        4711: {
            tokenId: '4711',
            name: 'CryptoMorie #4711',
            contractAddress: '0xe785e82358879f061bc3dcac6f0444462d4b5330',
        },
        8241: {
            tokenId: '8241',
            name: 'CryptoMorie #8241',
            contractAddress: '0xe785e82358879f061bc3dcac6f0444462d4b5330',
        },
    },
    moonbirds: {
        9843: {
            tokenId: '9843',
            name: 'CryptoMorie #9843',
            contractAddress: '0x23581767a106ae21c074b2276D25e5C3e136a68b',
        },
    },
    mfers: {
        4863: {
            tokenId: '4863',
            name: 'CryptoMorie #4863',
            contractAddress: '0x79fcdef22feed20eddacbb2587640e45491b757f',
        },
        9550: {
            tokenId: '9550',
            name: 'CryptoMorie #9550',
            contractAddress: '0x79fcdef22feed20eddacbb2587640e45491b757f',
        },
    },
    lazylions: {
        1819: {
            tokenId: '1819',
            name: 'CryptoMorie #1819',
            contractAddress: '0x8943c7bac1914c9a7aba750bf2b6b09fd21037e0',
        },
        2249: {
            tokenId: '2249',
            name: 'CryptoMorie #2249',
            contractAddress: '0x8943c7bac1914c9a7aba750bf2b6b09fd21037e0',
        },
        8159: {
            tokenId: '8159',
            name: 'CryptoMorie #8159',
            contractAddress: '0x8943c7bac1914c9a7aba750bf2b6b09fd21037e0',
        },
    },
    guttercat: {
        1043: {
            tokenId: '1043',
            name: 'CryptoMorie #1043',
            contractAddress: '0xEdB61f74B0d09B2558F1eeb79B247c1F363Ae452',
        },
        2476: {
            tokenId: '2476',
            name: 'CryptoMorie #2476',
            contractAddress: '0xEdB61f74B0d09B2558F1eeb79B247c1F363Ae452',
        },
        2903: {
            tokenId: '2903',
            name: 'CryptoMorie #2903',
            contractAddress: '0xEdB61f74B0d09B2558F1eeb79B247c1F363Ae452',
        },
    },
    deadfellas: {
        1056: {
            tokenId: '1056',
            name: 'CryptoMorie #1056',
            contractAddress: '0x2acAb3DEa77832C09420663b0E1cB386031bA17B',
        },
        7258: {
            tokenId: '7258',
            name: 'CryptoMorie #7258',
            contractAddress: '0x2acAb3DEa77832C09420663b0E1cB386031bA17B',
        },
    },
    cyberkongs: {
        4202: {
            tokenId: '4202',
            name: 'CryptoMorie #4202',
            contractAddress: '0x57a204AA1042f6E66DD7730813f4024114d74f37',
        },
        4824: {
            tokenId: '4824',
            name: 'CryptoMorie #4824',
            contractAddress: '0x57a204AA1042f6E66DD7730813f4024114d74f37',
        },
    },
    cryptomorie: {
        8815: {
            tokenId: '8815',
            name: 'CryptoMorie #8815',
            contractAddress: '0x1a2F71468F656E97c2F86541E57189F59951efe7',
        },
        3072: {
            tokenId: '3072',
            name: 'CryptoMorie #3072',
            contractAddress: '0x1a2F71468F656E97c2F86541E57189F59951efe7',
        },
        6496: {
            tokenId: '6496',
            name: 'CryptoMorie #6496',
            contractAddress: '0x1a2F71468F656E97c2F86541E57189F59951efe7',
        },
    },
    cryptoadz: {
        192: {
            tokenId: '192',
            name: '3 Lander #192',
            contractAddress: '0x1cb1a5e65610aeff2551a50f76a87a7d3fb649c6',
        },
        3678: {
            tokenId: '3678',
            name: '3 Lander #3678',
            contractAddress: '0x1cb1a5e65610aeff2551a50f76a87a7d3fb649c6',
        },
    },
    coolcats: {
        2541: {
            tokenId: '2541',
            name: '3 Lander #2541',
            contractAddress: '0x1a92f7381b9f03921564a437210bb9396471050c',
        },
        3356: {
            tokenId: '3356',
            name: '3 Lander #3356',
            contractAddress: '0x1a92f7381b9f03921564a437210bb9396471050c',
        },
    },
    chain_runner: {
        4160: {
            tokenId: '4160',
            name: 'Chain Runner #4160',
            contractAddress: '0x97597002980134bea46250aa0510c9b90d87a587',
        },
        1440: {
            tokenId: '1440',
            name: 'Chain Runner #1440',
            contractAddress: '0x97597002980134bea46250aa0510c9b90d87a587',
        },
        7607: {
            tokenId: '7607',
            name: 'Chain Runner #7607',
            contractAddress: '0x97597002980134bea46250aa0510c9b90d87a587',
        },
    },
    kennel: {
        8494: {
            tokenId: '8494',
            name: '3 Lander #8494',
            contractAddress: '0xba30E5F9Bb24caa003E9f2f0497Ad287FDF95623',
        },
    },
    azuki: {
        6352: {
            tokenId: '6352',
            name: '3 Lander #6352',
            contractAddress: '0xED5AF388653567Af2F388E6224dC7C4b3241C544',
        },
    },
    landers: {
        2238: {
            tokenId: '2238',
            name: '3 Lander #2238',
            contractAddress: '0xb4d06d46A8285F4EC79Fd294F78a881799d8cEd9',
        },
        4071: {
            tokenId: '4071',
            name: '3 Lander #4071',
            contractAddress: '0xb4d06d46A8285F4EC79Fd294F78a881799d8cEd9',
        },
        4270: {
            tokenId: '4270',
            name: '3 Lander #4270',
            contractAddress: '0xb4d06d46A8285F4EC79Fd294F78a881799d8cEd9',
        },
        8451: {
            tokenId: '8451',
            name: '3 Lander #8451',
            contractAddress: '0xb4d06d46A8285F4EC79Fd294F78a881799d8cEd9',
        },
    },
    alien_frens: {
        4069: {
            tokenId: '4069',
            name: 'Mutant Ape #4069',
            contractAddress: '0x123b30E25973FeCd8354dd5f41Cc45A3065eF88C',
        },
        4807: {
            tokenId: '4807',
            name: 'Mutant Ape #4807',
            contractAddress: '0x123b30E25973FeCd8354dd5f41Cc45A3065eF88C',
        },
        6011: {
            tokenId: '6011',
            name: 'Mutant Ape #6011',
            contractAddress: '0x123b30E25973FeCd8354dd5f41Cc45A3065eF88C',
        },
    },
    apes: {
        1638: {
            tokenId: '1638',
            name: 'Bored Ape #1638',
            contractAddress: '0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d',
        },
        6035: {
            tokenId: '6035',
            name: 'Bored Ape #6035',
            contractAddress: '0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d',
        },
        1781: {
            tokenId: '1781',
            name: 'Bored Ape #1781',
            contractAddress: '0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d',
        },
        2344: {
            tokenId: '2344',
            name: 'Bored Ape #2344',
            contractAddress: '0xbc4ca0eda7647a8ab7c2061c2e118a18a936f13d',
        },
    },
    mutant_ape: {
        5076: {
            tokenId: '5076',
            name: 'Mutant Ape #5076',
            contractAddress: '0x60E4d786628Fea6478F785A6d7e704777c86a7c6',
        },
    },
};
//# sourceMappingURL=cast.js.map